// The Vite config and scripts/post-build.ts (run by plain Node) import this
// file, so it can't use the @ui alias or an extensionless path.
import { DEFAULT_SOCIAL_DESCRIPTION } from "../../../frontend/src/lib/seo.ts"

// Routes with a static Markdown representation, built from their prerendered
// HTML (/pricing writes its own from its rate data; see build/pricing-markdown.ts).
// Each route's meta description reads from here, and llms.txt lists the pages
// with the same title and description.
export const marketingPages = {
  "/": {
    title: "Entire",
    description: DEFAULT_SOCIAL_DESCRIPTION,
  },
  "/features/trails": {
    title: "Trails",
    description:
      "Take work from idea to merge. Connect context, changes across repositories, agent sessions, and reviews in one Entire Trail.",
  },
  "/features/cli": {
    title: "Entire CLI",
    description:
      "Capture agent sessions alongside your commits, search past work, and resume across agents with the Entire CLI.",
  },
  "/features/code-hosting": {
    title: "Code Hosting",
    description:
      "Host your code or mirror your GitHub repositories on the fastest Git forge on Earth. Keep code close to every team and agent.",
  },
  "/features/sessions": {
    title: "Sessions",
    description:
      "Your code tells you what changed. Sessions tell you why. Explore the agent prompts, tool calls, and decisions behind your commits.",
  },
  "/features/plugins": {
    title: "Plugins",
    description:
      "Give your product first-class access to everything Entire: the code, the sessions, the trails, and everything in between. Apply to become a launch partner.",
  },
  "/about/india": {
    title: "Entire in India",
    description:
      "Host your repositories in India, mirror your GitHub repos, and keep agent sessions and decisions alongside your commits with Entire.",
  },
  "/about/projects": {
    title: "Projects",
    description:
      "Git hosting, Git sync, Sessions, Skills, and the CLI: the building blocks of a developer platform where agents and humans collaborate.",
  },
  "/about/company": {
    title: "Company",
    description:
      "Meet Entire’s globally distributed team and explore our mission, values, and approach to building the next developer platform.",
  },
  "/about/vision": {
    title: "Vision",
    description:
      "The world's next developer platform, where agents and humans can collaborate, learn and ship together.",
  },
  "/pricing": {
    title: "Pricing",
    description:
      "Early access pricing is pay-as-you-go. Entire users get a one-time credit, then buy more and keep using their agents at model provider rates.",
  },
  "/brand": {
    title: "Brand",
    description:
      "Download Entire logos and brand assets, and find guidelines for naming, logo usage, and color.",
  },
} satisfies Record<string, { title: string; description: string }>

export function isMarketingPage(pathname: string): boolean {
  return Object.hasOwn(marketingPages, pathname)
}

/** The URL of a page's Markdown. `/.md` is not a usable URL, so the homepage's is `/index.md`. */
export function markdownPath(pathname: string): string {
  return pathname === "/" ? "/index.md" : `${pathname}.md`
}

/** The visual sitemap renders its map in the browser, so its Markdown is written from the site graph. */
export const SITEMAP_PATH = "/sitemap"

/** Routes whose Markdown is a static file in the client build, next to their prerendered HTML. */
export function hasStaticMarkdown(pathname: string): boolean {
  return isMarketingPage(pathname) || pathname === SITEMAP_PATH
}
